import { MultilingualText, Tag, WorkCategory } from "./work"

export enum YearFilterValues {
  before1945 = "before1945",
  after1945 = "after1945",
}

export type CategoryFilterValues = WorkCategory;

export type TagFilterValue = Tag;
export type TagsFilterValues = Array<TagFilterValue>;

export type FilterListEntry<
  T = YearFilterValues | CategoryFilterValues | TagFilterValue
> = {
  label: string
  value: T
}
